import styled from 'styled-components';

export const MissingDataFrameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.paddingLG}px;
  width: 100%;
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const FrameHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme: { token } }) => token.paddingXXL * 2}px;

  .header-content {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.paddingSM}px;
  }

  .progress-container {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.paddingSM}px;
  }

  .percentage-text {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }
`;

export const MissingDataContent = styled.div`
  display: flex;
  gap: ${({ theme: { token } }) => token.padding}px;
  width: 100%;
  overflow-x: auto;
  justify-content: flex-start;
`;

export const BucketCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme: { token } }) => token.padding}px;
  padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingSM}px 0px;
  flex: none;
  background: ${({ theme: { token } }) => token.colorBgContainer};
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  box-sizing: border-box;
`;

export const BucketHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.paddingSM}px;
  width: 100%;

  .bucket-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }

  .bucket-progress {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.paddingSM}px;
  }

  .title-text {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    line-height: ${({ theme: { token } }) => token.lineHeightSM};
    color: ${({ theme: { token } }) => token.colorWhite};
    word-wrap: break-word;
  }
`;

export const BucketContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
  width: 100%;
  height: ${({ theme: { token } }) => token.paddingLG * 9 + token.paddingSM}px;
  overflow-y: auto;

  .spec-item {
    background: ${({ theme: { token } }) => token.colorFillQuaternary};
    border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;

    &:hover {
      background: ${({ theme: { token } }) => token.colorFillTertiary};
    }
  }

  .item-content {
    display: flex;
    align-items: flex-end;
    gap: ${({ theme: { token } }) => token.paddingLG + token.marginXS}px;
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;
    width: 100%;
  }

  .text-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginXXS}px;
    flex: 1;
    max-width: ${({ theme: { token } }) => token.paddingLG * 18 + token.paddingSM}px;
  }

  .item-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    line-height: ${({ theme: { token } }) => token.lineHeightSM};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .item-description {
    font-weight: ${({ theme: { token } }) => token.fontWeight};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    line-height: ${({ theme: { token } }) => token.lineHeightSM};
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    width: 100%;
    word-wrap: break-word;
  }

  .item-actions {
    display: flex;
    padding: 0px ${({ theme: { token } }) => token.paddingSM}px 0px
      ${({ theme: { token } }) => token.paddingLG + token.padding}px;
    flex-shrink: 0;

    .action-link {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-weight: ${({ theme: { token } }) => token.fontWeight};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      line-height: ${({ theme: { token } }) => token.lineHeightSM};

      &:hover,
      &:focus {
        color: ${({ theme: { token } }) => token.colorPrimaryHover};
      }
    }
  }
`;

export const SensorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
  width: 100%;
  overflow-y: auto;
`;

export const StationReadinessCollapseContainer = styled.div`
  padding: 0 ${({ theme: { token } }) => token.padding}px;

  .custom-collapse {
    background: ${({ theme: { token } }) => token.colorPrimaryBg};
    border: 1px dashed ${({ theme: { token } }) => token.colorPrimary};

    .custom-collapse-item {
      border-radius: ${({ theme: { token } }) => token.borderRadius}px;
      background-color: transparent;
      margin-bottom: 0;

      .custom-collapse-header {
        padding: 0px ${({ theme: { token } }) => token.padding}px;
        min-height: ${({ theme: { token } }) => token.paddingLG + token.padding}px;
        display: flex;
        align-items: center;

        &:hover {
          background: ${({ theme: { token } }) => token.colorBgTextHover};
        }
      }

      .custom-collapse-content {
        padding: 0;
        background: transparent;
      }
    }
  }

  .collapse-content-wrapper {
    background: ${({ theme: { token } }) => token.colorPrimaryBg};
    min-height: 100%;
  }

  .custom-expand-icon-wrapper {
    padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
  }

  .custom-expand-icon {
    transition: transform 0.2s;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};

    &.active {
      transform: rotate(180deg);
    }

    &.inactive {
      transform: rotate(0deg);
    }
  }

  .readiness-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .readiness-content {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.paddingSM}px;
      flex: 1;
    }

    .progress-container {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.paddingSM}px;
    }

    .percentage-text {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      line-height: ${({ theme: { token } }) => token.lineHeightSM};
      color: ${({ theme: { token } }) => token.colorWhite};
    }

    .description-text {
      font-weight: ${({ theme: { token } }) => token.fontWeight};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      line-height: ${({ theme: { token } }) => token.lineHeight};
      color: ${({ theme: { token } }) => token.colorPrimary};
    }

    .button-text {
      font-weight: ${({ theme: { token } }) => token.fontWeight};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      line-height: ${({ theme: { token } }) => token.lineHeight};
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }
  }
`;
